import React from "react";
import { AlertTriangle, X } from "lucide-react";

/**
 * Reusable styled Yes/No confirmation dialog.
 * Renders above other modals (z-[1100]). Used to gate destructive actions
 * (e.g. inventory reversal) before the API call.
 */
export default function ConfirmDialog({
  open,
  title = "Please confirm",
  message,
  confirmLabel = "Yes",
  cancelLabel = "No",
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[1100] flex items-center justify-center bg-black/50 p-4"
      onClick={(e) => { if (e.target === e.currentTarget && !loading) onCancel && onCancel(); }}
    >
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
        <div className="flex items-start gap-3 px-6 pt-6">
          <div className="shrink-0 w-10 h-10 rounded-full bg-rose-50 flex items-center justify-center">
            <AlertTriangle className="w-5 h-5 text-[#EE3B31]" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            <p className="mt-1 text-sm text-gray-600 leading-relaxed">{message}</p>
          </div>
          <button
            onClick={() => !loading && onCancel && onCancel()}
            className="text-gray-400 hover:text-gray-600 p-1"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        <div className="flex justify-end gap-3 px-6 pb-5 pt-6">
          <button
            onClick={() => !loading && onCancel && onCancel()}
            disabled={loading}
            className="px-4 py-2 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 text-sm disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-5 py-2 rounded-lg bg-[#EE3B31] hover:bg-[#d43229] text-white font-semibold text-sm disabled:opacity-50"
          >
            {loading ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
